export default {
  setCommunity(state, community) {
    state.community = community;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setLoaded(state, loaded) {
    state.loaded = loaded;
  }
};
